jQuery(document).ready(function () {
    if (jQuery("div").hasClass("slider-variant")) {
        jQuery("div.slider-variant").append("<div class='scroll-down'></div>");
    }

    jQuery(document).on('click', '.scroll-down', function () {
        var height = jQuery(this).parent().height();
        var position = jQuery(this).parent().position();
        var newScrollPosition = position.top + height;


        jQuery('html,body').animate({
            scrollTop: newScrollPosition + 'px'
        });
    });

    jQuery('#corner-popup').delay(5000).fadeIn(0);
});

function hide(target) {
    document.getElementById(target).style.display = 'none';
}